<template>
  <v-card>
    <v-toolbar color="white" class="elevation-1">
      <v-toolbar-title class="black--text font-weight-light">Posto de Serviço</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn title="Cancelar" @click.native="cancel();" :disabled="loading" flat color="error" icon round >
        <v-icon large color="error">clear</v-icon>
      </v-btn>

    </v-toolbar>
    <v-card-text class="pb-0">
      <v-text-field label="Descrição" v-model="target.description" box></v-text-field>
      <v-currency-field 
        box
        label="Valor(R$)" 
        v-bind="currency_config"
        v-model="target.value">
      </v-currency-field>
      <v-text-field label="Observação" v-model="target.observation" box></v-text-field>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1" @click.native="save();">Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {
    mapActions
  } from "vuex";
import Currency from '../../utils/Currency';

  export default {
    name: "FormSetServiceStation",

    data() {
      return {
        loading: false,
        isEdition: false,
        currency_config: Currency.real,
      };
    }, // data() //

    methods: {
      init() {}, //init()//

      async closeThisForm() {
        this.setServiceStation({});
        await this.$store.commit("SET_SERVICE_STATION", {});
        this.$eventHub.$emit("closeFormServiceStation");
      }, //closeThisForm()//

      cancel() {
        this.closeThisForm();
      }, //cancel()//

      save() {
        if (this.isEdition) {
          this.setServiceStation(this.target);
          this.$eventHub.$emit("saveFormServiceStation", this.isEdition);
          this.closeThisForm();
          this.isEdition = false;
        } else {
          this.setServiceStation(this.target);
          this.$eventHub.$emit("saveFormServiceStation", this.isEdition);
          this.closeThisForm();
        }
      }, //save()//

      ...mapActions(["setServiceStation"])
    }, //methods//

    created() {
      this.init();
    }, //created()//

    computed: {
      target() {
        console.log("AQUI")
        console.log(this.editing)
        if(!this.editing)
          return {description: "", value: 0, observation: ""}

        if (!this.$store.getters.getServiceStationOfCollectiveConvention) {
          this.isEdition = false;
          return {};
        } else {
          this.isEdition = true;
          return this.$store.getters.getServiceStationOfCollectiveConvention;
        }
      }
    }, 
    props:{
      editing: Boolean
    }
    
    
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/collective_convention/FormServiceStation.vue